import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, take } from 'rxjs';

/**
 * Prevents already authenticated users from visiting guest-only pages (e.g. /realm),
 * redirecting them to the Starting Page instead.
 */
export const guestGuard: CanMatchFn = () => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return oidcSecurityService.isAuthenticated$.pipe(
    take(1),
    map(({ isAuthenticated }) => (isAuthenticated ? router.parseUrl('/') : true))
  );
};
